import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import { useSettingsStore } from '@/store/modules/settings';
import getPageTitle from '@/utils/pageTitle';

import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import { storeToRefs } from 'pinia';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const {
      locale
    } = useI18n();
    const route = useRoute();
    const settingsStore = useSettingsStore();
    const {
      theme
    } = storeToRefs(settingsStore);
    const {
      changeLanguage
    } = settingsStore;
    const handleCommand = language => {
      changeLanguage(language);
      locale.value = language;
      document.title = getPageTitle(route.meta.title);
    };
    return (_ctx, _cache) => {
      const _component_vab_icon = _resolveComponent("vab-icon");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      return _unref(theme).showLanguage ? (_openBlock(), _createBlock(_component_el_dropdown, {
        key: 0,
        onCommand: handleCommand
      }, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
            command: "zh"
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createTextVNode("中文简体", -1)]))]),
            _: 1
          }), _createVNode(_component_el_dropdown_item, {
            command: "en"
          }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode("English", -1)]))]),
            _: 1
          })]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_vab_icon, {
          icon: "translate"
        })]),
        _: 1
      })) : _createCommentVNode("", true);
    };
  }
});